var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 5C1 2.79086 2.79086 1 5 1H12V35H5C2.79086 35 1 33.2091 1 31V5Z",
    fill: "#90CAF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 1.94444V1H12H11.5V1.94444H12.5ZM12.5 5.72222V3.83333H11.5V5.72222H12.5ZM12.5 9.5V7.61111H11.5V9.5H12.5ZM12.5 13.2778V11.3889H11.5V13.2778H12.5ZM12.5 17.0556V15.1667H11.5V17.0556H12.5ZM12.5 20.8333V18.9444H11.5V20.8333H12.5ZM12.5 24.6111V22.7222H11.5V24.6111H12.5ZM12.5 28.3889V26.5H11.5V28.3889H12.5ZM12.5 32.1667V30.2778H11.5V32.1667H12.5ZM11.5 35V34.0556H12.5V35H12H11.5Z",
    fill: "#2196F3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 34,
    height: 34,
    rx: 4,
    stroke: "#2196F3",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertical);
export default __webpack_public_path__ + "static/media/vertical.d0f796a648b8a1af0834620bf00cf8cb.svg";
export { ForwardRef as ReactComponent };